import React from 'react'

import { i18n } from '~/i18n'

import { Body } from './summit-support-summary.styles'

type Props = {
  className?: string
}

export default function SummitSupportSummary({ className }: Props) {
  return (
    <div className={className}>
      <Body>{i18n.t('components.summit_support_summary.body')}</Body>
    </div>
  )
}
